/**
 * @Author: WangZhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 15:43:05
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageLuBang.js
 * @Description: 鲁棒性检测
 */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import {fetchLeaderBoard} from '../../actions/luBangAction';

class PageLuBang extends PureComponent {
    static propTypes = {
        bannerInfo: PropTypes.object,
        fetchLeaderBoard: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            objClass: {},
            objTarget: {},
            off1: false,
            off2: false
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = '/newsite/robustness';
        }
    }

    componentDidMount() {
        this.props.fetchLeaderBoard({type: 'classification'}).then(data => {
            if (data.data.status === 0) {
                this.setState({
                    objClass: data.data.data.classification || {}
                });
            }
        });
        this.props.fetchLeaderBoard({type: 'target'}).then(data => {
            if (data.data.status === 0) {
                this.setState({
                    objTarget: data.data.data.target || {}
                });
            }
        });
    }

    setValFn = s => {
        let str = '';
        s = s.toString().substr(2, s.length).split('');

        for (let i = 0; i < s.length; i++) {

            if (s[i] > 0) {
                str = `${s[i]}e-${i + 1}`;
                break;
            }
        }
        return str;
    };

    render() {
        const bannerInfo = this.props.bannerInfo || {};
        let {objClass, objTarget, off1, off2} = this.state;

        return (
            <div className={'product lubang'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    {'基于百度安全深度学习模型安全评估框架，对AI模型在多个安全维度进行鲁棒性检测，为研究人员和用户提升AI模型质量，'
                    + '降低由于客观真实环境变化或恶意攻击造成的安全隐患。'}
                </div>

                <div className={'lb-box1'}>
                    <div className={'product-mod'}>
                        <ProductTitle title={'产品功能'}/>
                    </div>

                    <div className={'lb-mod1'}>
                        <div>
                            <div className={'title'}>鲁棒性检测</div>
                            <div className={'text'}>对上传的AI模型进行鲁棒性检测，可按需设置评测属性、评测标准、以及鲁棒性度量标准。</div>
                        </div>
                        <div>
                            <div className={'title'}>欺骗性样本</div>
                            <div className={'text'}>如果用户需要，平台可以提供欺骗模型的输入样本数据集。</div>
                        </div>
                        <div>
                            <div className={'title'}>检测报告</div>
                            <div className={'text'}>提供检测结果，支持对不同的安全属性，展示与其他预训练模型之间的比较。</div>
                        </div>

                        {/* <a href={'/console/#/robustness'} target={'_blank'} className={'m-btn'}>开始检测</a> */}
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'}/>
                </div>

                <div className={'product-mod'}>
                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/product/lbcj1.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            新开发AI模型
                        </div>
                        <div className={'pro-app-content'}>
                            对新开发的AI模型做鲁棒性检测，提前发现问题并进行修复，提高模型的安全性。
                        </div>
                    </div>
                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/product/lbcj2.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            AI模型升级
                        </div>
                        <div className={'pro-app-content'}>
                            AI模型升级后进行鲁棒性检测，发现升级问题，提高模型的安全性。
                        </div>
                    </div>
                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/product/lbcj3.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            AI模型不定期检测
                        </div>
                        <div className={'pro-app-content'}>
                            鲁棒性检测会持续更新检测能力，更新后可为AI模型做多检测。
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'产品特色'}/>
                </div>

                <div className={'product-mod'}>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/icon_duopingtai.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>多平台支持</div>
                            <div className={'proinfo-box-des'}>
                                {'鲁棒性测试代码可以无需修改地对多种热门深度学习框架下的模型进行标准化评测，支持的框架包'
                                + '括：Keras, PyTorch'}
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/icon_duorenwu.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>多任务支持</div>
                            <div className={'proinfo-box-des'}>
                                {'目前所有的对抗机器学习库都仅支持基础的图像分类任务，Perceptron 支持包括对无人驾驶'
                                + '意义重大的目标检测模型在内的多种视觉任务'}
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/icon_yunduanheihe.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>云端黑盒模型支持</div>
                            <div className={'proinfo-box-des'}>
                                {'Perceptron同时也支持对 MLaaS 场景下封装后的云端模型API的鲁棒性度量，我们为包括'
                                + 'Google Cloud Vision, Baidu AIP, Amazon Rekognition在内的多个商用AI平台提'
                                + '供了便于测试的接口'}
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/icon_biaozhunhua.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>标准化度量</div>
                            <div className={'proinfo-box-des'}>
                                {'Perceptron Robustness Benchmark 所给出的模型鲁棒性度量可以用来进行多任务，'
                                + '多模型间的比较，并可被用来作为对模型鲁棒性上界的估计'}
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/icon_keyanzheng.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>可验证的鲁棒性</div>
                            <div className={'proinfo-box-des'}>
                                {'Perceptron Robustness Benchmark 使用形式化验证的方法，通过符号区间分'
                                + '析 (symbolic interval analysis) 为模型计算出可信赖的鲁棒性下界，即当'
                                + '叠加在样本上的扰动小于该下界，模型能够确保预测结果的一致性'}
                            </div>
                        </div>
                    </div>
                </div>


                <div className={'lb-box2'}>
                    <div className={'product-mod'}>
                        <ProductTitle title={'鲁棒性排行榜'}/>
                    </div>
                    <div className={'lb-mod4'}>
                        <div className={'title'}>分类错误鲁棒性排行榜</div>

                        {
                            Object.keys(objClass).map((item, index) => {
                                let data = objClass[item];
                                if (index > 1 && !off1) {
                                    return null;
                                }
                                return <div className={'item'} key={index}>
                                    <div className={'title'}>
                                        {data[0].attributes}
                                    </div>
                                    <div>
                                        {data.map((item2, index2) => {
                                            let score = this.setValFn(item2.score);
                                            let firstVal = score[0];
                                            let lastVal = score[score.length - 1];
                                            let w = (6 - lastVal) * 0.81 + (0.81 * firstVal / 10);
                                            let n = w / 4.86 * 100;
                                            let c = '';
                                            switch (true) {
                                                case n >= 80:
                                                    c = 'c1';
                                                    break;
                                                case n >= 60 && n < 80:
                                                    c = 'c2';
                                                    break;
                                                case n >= 40 && n < 60:
                                                    c = 'c3';
                                                    break;
                                                case n >= 20 && n < 40:
                                                    c = 'c4';
                                                    break;
                                                case n >= 0 && n < 20:
                                                    c = 'c5';
                                                    break;
                                            }
                                            return <div className={'list'} key={index2}>
                                                <div className={'list-title'}>{item2.name}</div>
                                                <div className={`list-num ${c}`} style={{width: `${w}rem`}}/>
                                                <div className={'list-val'}>{score}</div>
                                            </div>;
                                        })}
                                    </div>
                                </div>;
                            })
                        }
                        {
                            Object.keys(objClass).length > 2
                                ? <div
                                    className={'linkText'}
                                    onClick={() => {
                                        this.setState({
                                            off1: !off1
                                        });
                                    }}
                                >
                                    {off1 ? '收起' : '加载更多'}
                                </div>
                                : null
                        }
                    </div>
                    <div className={'lb-mod4 mt40'}>
                        <div className={'title'}>目标识别错误鲁棒性排行榜</div>

                        {
                            Object.keys(objTarget).map((item, index) => {
                                let data = objTarget[item];
                                if (index > 1 && !off2) {
                                    return null;
                                }
                                return <div className={'item'} key={index}>
                                    <div className={'title'}>
                                        {data[0].attributes}
                                    </div>
                                    <div>
                                        {data.map((item2, index2) => {
                                            let score = this.setValFn(item2.score);
                                            let firstVal = score[0];
                                            let lastVal = score[score.length - 1];
                                            let w = (6 - lastVal) * 0.81 + (0.81 * firstVal / 10);
                                            let n = w / 4.86 * 100;
                                            let c = '';
                                            switch (true) {
                                                case n >= 80:
                                                    c = 'c1';
                                                    break;
                                                case n >= 60 && n < 80:
                                                    c = 'c2';
                                                    break;
                                                case n >= 40 && n < 60:
                                                    c = 'c3';
                                                    break;
                                                case n >= 20 && n < 40:
                                                    c = 'c4';
                                                    break;
                                                case n >= 0 && n < 20:
                                                    c = 'c5';
                                                    break;
                                            }
                                            return <div className={'list'} key={index2}>
                                                <div className={'list-title'}>{item2.name}</div>
                                                <div className={`list-num ${c}`} style={{width: `${w}rem`}}/>
                                                <div className={'list-val'}>{score}</div>
                                            </div>;
                                        })
                                        }
                                    </div>
                                </div>;
                            })
                        }
                        {
                            Object.keys(objTarget).length > 2
                                ? <div
                                    className={'linkText'}
                                    onClick={() => {
                                        this.setState({
                                            off2: !off2
                                        });
                                    }}
                                >
                                    {off2 ? '收起' : '加载更多'}
                                </div>
                                : null
                        }
                    </div>
                </div>


            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchLeaderBoard: (obj, type) => fetchLeaderBoard(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageLuBang);



// WEBPACK FOOTER //
// ./src/containers/product/pageLuBang.js